import React from 'react';
import './skeleton.scss';

interface SkeletonProps {
  type: 'navbar' | 'form' | 'search-table' | 'table' | 'double-bar-table';
}

function NavbarSkeleton() {
  return (
    <div
      data-testid="skeleton skeleton-navbar"
      className="skeleton skeleton__navbar"
    />
  );
}

function FormSkeleton() {
  return (
    <div data-testid="skeleton skeleton-form">
      <div className="skeleton skeleton__header" />
      <div className="skeleton skeleton__block" />
    </div>
  );
}

function SearchTableSkeleton() {
  return (
    <div data-testid="skeleton skeleton-search-table">
      <div className="skeleton skeleton__search" />
      <TableSkeleton />
    </div>
  );
}

function TableSkeleton() {
  const elements = new Array(30).fill(null).map((e, i) => i);
  return (
    <div data-testid="skeleton skeleton-table">
      {elements.map((e) => (
        <div
          key={e}
          data-testid="skeleton-row"
          className="skeleton skeleton__row"
        />
      ))}
    </div>
  );
}

function DoubleBarTable() {
  const elements = new Array(30).fill(null).map((e, i) => i);
  return (
    <div data-testid="skeleton skeleton-double-bar-table">
      <div className="skeleton skeleton__search" />
      <div className="skeleton skeleton__search" />
      {elements.map((e) => (
        <div
          key={e}
          data-testid="skeleton-row"
          className="skeleton skeleton__row"
        />
      ))}
    </div>
  );
}

export default function Skeleton(props: SkeletonProps) {
  switch (props.type) {
    case 'navbar':
      return <NavbarSkeleton />;
    case 'form':
      return <FormSkeleton />;
    case 'search-table':
      return <SearchTableSkeleton />;
    case 'table':
      return <TableSkeleton />;
    case 'double-bar-table':
      return <DoubleBarTable />;
  }
}
